import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment-timezone'

import { momentLocaleFor } from 'i18n/formatDate'

export const useCurrentTime = (timezone = moment.tz.guess()) => {
  const { i18n } = useTranslation()
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  const locale = momentLocaleFor(i18n.language)
  const formattedTime = timezone
    ? moment(currentTime).tz(timezone).locale(locale).format('LT')
    : moment().locale(locale).format('LT')

  return formattedTime
}
